import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
// import { TruncatePipe } from "src/app/pipe/truncate.pipe";
declare var $:any;

@Component({
  selector: 'app-static-list',
  templateUrl: './static-list.component.html',
  // standalone: true,
  // imports: [ TruncatePipe],
  styleUrls: ['./static-list.component.scss']
})
export class StaticListComponent {

  public dataListing:any=[];
  public AllData:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit:any = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  
  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('gra_login') || "{}");   
    this.getDetail(this.p);
   }

  ngOnInit(): void {
  }

  getDetail(page:any){  
    this.loading = true;    
        var url='/static-page?page='+page+'&search='+this.searchKey;      
        this.service.GetApi(url).subscribe(((response:any)=>{  
        if(response.success ==1) {  
          this.dataListing= response.data.record;  
          this.loading=false;
        } else {
          this.dataListing=[];  
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
  }

    redirect(item:any){
    localStorage.setItem('gra_EditData',JSON.stringify(item));
        this.router.navigate(['/update-static']);
    }


  
}
